// @mui
import { Typography, Stack, Box, Avatar } from "@mui/material";
//
import { StyledRoot, StyledSectionBg, StyledContent } from "./styles";
import { Outlet } from "react-router";
import { COMPANY_NAME } from "src/config";
import Logo from "src/components/logo";
import { Helmet } from "react-helmet-async";

// ----------------------------------------------------------------------

export default function GuestLayout() {
  return (
    <StyledRoot>
      <Helmet>
        <title> {COMPANY_NAME}</title>
      </Helmet>
      <Box sx={{ position: "absolute", top: 10, left: 10 }}>
        <Logo />
      </Box>
      <StyledContent>
        {" "}
        <Stack sx={{ width: 1, height: "fit-content" }}>
          <Outlet />
        </Stack>
      </StyledContent>
      <StyledSectionBg />
    </StyledRoot>
  );
}
